export type AssistEventPayload = {
  name?: string
  normalizedName?: string
  parameters?: Record<string, unknown>
}

export const matchesOrganization = (payload: AssistEventPayload, organizationId?: string) => {
  const params = payload.parameters ?? {}
  const targetOrg =
    (params.organization_id as string | undefined) ??
    (params.organizationId as string | undefined) ??
    (params.org_id as string | undefined)

  if (targetOrg && organizationId && targetOrg !== organizationId) {
    return false
  }

  const normalized = (payload.normalizedName ?? payload.name ?? "").toLowerCase()

  return (
    normalized.includes("work_order") ||
    normalized.includes("order") ||
    normalized.includes("schedule") ||
    normalized.includes("appointment")
  )
}
